module.exports = __webpack_public_path__ + "static/media/IconANTActive.ff7bd924.svg";